import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner.component';
import { RouterModule } from '@angular/router';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [BannerComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatProgressBarModule
  ],
  exports: [BannerComponent]
})
export class BannerModule { }
